import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "@/i18n/strings";

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(
        () => localStorage.getItem("flow_lang") || "en",
    );
    useEffect(() => {
        localStorage.setItem("flow_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);
    const t = STRINGS[lang] || STRINGS.en;
    return (
        <LangContext.Provider value={{ lang, setLang, t, toggle: () => setLang((l) => (l === "en" ? "es" : "en")) }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
